import { Box, Button, Chip, Grid, MenuItem, Popover, Stack } from '@mui/material';
import SelectField from 'common/forms/SelectField';
import { capitalize, omit } from 'lodash';
import { useState } from 'react';
import { Form } from 'react-final-form';
import { useFillHistoryUpdateReport } from '../hooks/useFillHistoryUpdateReport';

const FillHistoryUpdateReportFillterButton = () => {
  const { filter, setFilter } = useFillHistoryUpdateReport();
  const [anchorEl, setAnchorEl] = useState(null);

  const popoverId = anchorEl ? 'PartnerFilterButton-Popover' : undefined;

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleApplyFilter = ({ fileType }) => {
    setFilter({ fileType: fileType || undefined });
    handleClose();
  };

  const removeFilter = (filterName) => () => setFilter(omit(filter, filterName));

  return (
    <Grid container justifyContent='space-between'>
      <Box>
        <Stack direction='row' spacing={1}>
          {filter?.fileType && (
            <Chip
              label={`Type = ${capitalize(filter.fileType)}`}
              onDelete={removeFilter('fileType')}
            />
          )}
        </Stack>
      </Box>
      <Button variant='contained' onClick={handleOpen}>
        Filter
      </Button>
      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField
                      label='Type'
                      name='fileType'
                      id='FillHistoryUpdateReportFilter-fileType-dropdown'
                      lexicographicSort={false}
                    >
                      <MenuItem value=''>All</MenuItem>
                      <MenuItem value='success'>Success</MenuItem>
                      <MenuItem value='failure'>Failure</MenuItem>
                    </SelectField>
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <Button type='submit' variant='contained' disabled={invalid}>
                      Apply
                    </Button>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </Grid>
  );
};

export default FillHistoryUpdateReportFillterButton;
